import { formatDateTime } from "features/discover/functions";
import { BooleanChoices } from "features/discover/types";
import { renderBoolean, renderNumber } from "../cellRenderers";
import {
	DatagridBackendFilterType,
	DatagridFilterInputType,
	type ColumnConfig,
	type FilterConfig,
} from "../types";
import type { TeamGroupRowResponse } from "libs/apiClient";

export type TeamGroupRow = TeamGroupRowResponse & Record<string, unknown>;

export const teamGroupsColumns: ColumnConfig<TeamGroupRow>[] = [
	{
		key: "id",
		label: "ID",
		sortable: true,
		sortField: "id",
		cell: (value) => (value !== null && value !== undefined ? String(value) : "-"),
		group: "Overview",
		defaultVisible: true,
		minWidth: 60,
		maxWidth: 100,
	},
	{
		key: "name",
		label: "Deal Name",
		sortable: true,
		sortField: "name",
		cell: (value) => (value as string) || "-",
		group: "Overview",
		defaultVisible: true,
		minWidth: 120,
		maxWidth: 320,
	},
	{
		key: "teamCount",
		label: "Number of Teams",
		headerTitle: "Numbers of teams that have Deal assigned",
		sortable: false,
		cell: (value) => renderNumber(value as number | null),
		group: "Overview",
		defaultVisible: true,
		width: 150,
	},
	{
		key: "gameCount",
		label: "Number of games",
		headerTitle: "Number of games in that Deal",
		sortable: false,
		cell: (value) => renderNumber(value as number | null),
		group: "Overview",
		defaultVisible: true,
		width: 150,
	},
	{
		key: "scoutVisibility",
		label: "Scout Visibility",
		sortable: true,
		sortField: "scoutVisibility",
		cell: (value) => renderBoolean(value),
		group: "Overview",
		defaultVisible: true,
		width: 140,
	},
	{
		key: "sharedAnalysis",
		label: "Shared Analysis",
		sortable: true,
		sortField: "sharedAnalysis",
		cell: (value) => renderBoolean(value),
		group: "Overview",
		defaultVisible: true,
		width: 140,
	},
	{
		key: "visibleTeamsheets",
		label: "Visible Teamsheets",
		sortable: true,
		sortField: "visibleTeamsheets",
		cell: (value) => renderBoolean(value),
		group: "Overview",
		defaultVisible: true,
		width: 160,
	},
	{
		key: "createdAt",
		label: "Created At",
		headerTitle: "Timestamp of deal creation",
		sortable: true,
		sortField: "createdAt",
		cell: (value) => formatDateTime(value as string | null),
		group: "Overview",
		defaultVisible: true,
		width: 160,
	},
	{
		key: "clubNames",
		label: "Clubs",
		sortable: false,
		cell: (value) => {
			if (value == null || value === "") {
				return "-";
			}

			return <div style={{ whiteSpace: "pre-line" }}>{String(value)}</div>;
		},
		group: "Linked",
		defaultVisible: false,
		width: 320,
	},
	{
		key: "directTeamNames",
		label: "Direct Teams",
		sortable: false,
		cell: (value) => {
			if (value == null || value === "") {
				return "-";
			}

			return <div style={{ whiteSpace: "pre-line" }}>{String(value)}</div>;
		},
		group: "Linked",
		defaultVisible: false,
		width: 420,
	},
	{
		key: "allTeamNames",
		label: "All Teams",
		sortable: false,
		cell: (value) => {
			if (value == null || value === "") {
				return "-";
			}

			return <div style={{ whiteSpace: "pre-line" }}>{String(value)}</div>;
		},
		group: "Linked",
		defaultVisible: false,
		width: 420,
	},
];

export const teamGroupsFilters: FilterConfig[] = [
	{
		id: "id",
		field: "id",
		label: "ID",
		type: DatagridFilterInputType.Text,
		filterType: DatagridBackendFilterType.Exact,
		placeholder: "ID",
	},
	{
		id: "name",
		field: "name",
		label: "Deal Name",
		type: DatagridFilterInputType.Text,
		filterType: DatagridBackendFilterType.Search,
		placeholder: "Deal Name",
	},
	{
		id: "teamId",
		field: "teamId",
		label: "Team",
		type: DatagridFilterInputType.Multiselect,
		filterType: DatagridBackendFilterType.Inarray,
		placeholder: "Teams",
	},
	{
		id: "scoutVisibility",
		field: "scoutVisibility",
		label: "Scout Visibility",
		type: DatagridFilterInputType.Boolean,
		filterType: DatagridBackendFilterType.Boolean,
		options: BooleanChoices,
	},
	{
		id: "sharedAnalysis",
		field: "sharedAnalysis",
		label: "Shared Analysis",
		type: DatagridFilterInputType.Boolean,
		filterType: DatagridBackendFilterType.Boolean,
		options: BooleanChoices,
	},
	{
		id: "visibleTeamsheets",
		field: "visibleTeamsheets",
		label: "Visible Teamsheets",
		type: DatagridFilterInputType.Boolean,
		filterType: DatagridBackendFilterType.Boolean,
		options: BooleanChoices,
	},
];
